import InfoIcon from "@material-ui/icons/InfoOutline"
import React from "react"
import { Admin, Resource } from "react-admin"
import About from "./About"
import authProvider from "./authProvider"
import dataProvider from "./dataProvider"
import LoginPage from "./LoginPage"

// tslint:disable:jsx-no-multiline-js

const App = () => (
  <Admin
    authProvider={authProvider}
    dataProvider={dataProvider}
    loginPage={LoginPage}
  >
    {() => [
      <Resource
        key="about"
        name="about"
        options={{ label: "About" }}
        icon={InfoIcon}
        list={About}
      />,
    ]}
  </Admin>
)

export default App
